var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34104 0.555934C8.10216 0.140209 11.8978 0.140209 15.6589 0.555934C17.7413 0.788946 19.4214 2.4261 19.6657 4.51229C20.1114 8.32057 20.1114 12.1677 19.6657 15.976C19.4214 18.0622 17.7413 19.6993 15.6589 19.9323C11.8978 20.3481 8.10216 20.3481 4.34104 19.9323C2.2586 19.6993 0.578547 18.0622 0.334198 15.976C-0.111399 12.1681 -0.111399 8.32138 0.334198 4.5135C0.457792 3.49998 0.92061 2.55783 1.64764 1.83974C2.37468 1.12165 3.32332 0.669702 4.33982 0.557148M9.99997 4.18461C10.2418 4.18461 10.4737 4.28051 10.6447 4.4512C10.8157 4.6219 10.9117 4.85341 10.9117 5.09482V9.33394H15.158C15.3999 9.33394 15.6318 9.42983 15.8027 9.60053C15.9737 9.77123 16.0698 10.0027 16.0698 10.2441C16.0698 10.4855 15.9737 10.7171 15.8027 10.8878C15.6318 11.0584 15.3999 11.1543 15.158 11.1543H10.9117V15.3935C10.9117 15.6349 10.8157 15.8664 10.6447 16.0371C10.4737 16.2078 10.2418 16.3037 9.99997 16.3037C9.75815 16.3037 9.52625 16.2078 9.35526 16.0371C9.18428 15.8664 9.08822 15.6349 9.08822 15.3935V11.1543H4.84189C4.60008 11.1543 4.36817 11.0584 4.19719 10.8878C4.0262 10.7171 3.93014 10.4855 3.93014 10.2441C3.93014 10.0027 4.0262 9.77123 4.19719 9.60053C4.36817 9.42983 4.60008 9.33394 4.84189 9.33394H9.08822V5.09482C9.08822 4.85341 9.18428 4.6219 9.35526 4.4512C9.52625 4.28051 9.75815 4.18461 9.99997 4.18461Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhite);
export default __webpack_public_path__ + "static/media/white+.7d2681b764fcd22c2696494e1fe09465.svg";
export { ForwardRef as ReactComponent };